import React from 'react';
import {
	GroupingState,
	IntegratedSelection,
	FilteringState,
	IntegratedFiltering,
	SelectionState,
} from '@devexpress/dx-react-grid';
import {
	Grid, VirtualTable, TableHeaderRow, TableSelection, TableFilterRow
} from '@devexpress/dx-react-grid-material-ui';
import moment from 'moment';
import ButtonBase from '@material-ui/core/ButtonBase';
import CircularProgress from '@material-ui/core/CircularProgress';


class MyActivitiesList extends React.Component {

	handleRowSelection = (selectedRows) => {
		console.log(selectedRows);
		var selectedRow;
		if (selectedRows.length > 1) { selectedRow = selectedRows[1] }
		if (selectedRows.length === 1) { selectedRow = selectedRows[0] }


		if (selectedRows.length > 0) {

			if (this.props.poster.template === 'singleRouteMap' || this.props.poster.template === 'complete') {

				//Single selection
				console.log('singleSelection');
				this.props.onSelectActivities([this.props.data.activities[selectedRow]], [selectedRow]);

				let activity = this.props.data.activities[selectedRow];

				this.props.onFetchActivity(activity.id, this.props.app.token);

				const { onChangeLabel } = this.props;
				onChangeLabel("title", activity.name);
				onChangeLabel("subtitle", moment(activity.start_date).format('YYYY-MM-DD HH:mm'));
				let dist = (activity.distance / 1000).toFixed(1)
				onChangeLabel("calculatedDistance", dist);


				onChangeLabel("time", moment.utc(activity.elapsed_time * 1000).format("HH:mm:ss"));
			} else {
				//Mulitple selection
				console.log('multipleSelection');
				let activities = this.props.data.activities;
				let selectedActivities = selectedRows.map(function (val, index) {
					return activities[val];
				});
				this.props.onSelectActivities(selectedActivities, selectedRows);

				let activity = selectedActivities[0];

				const { onChangeLabel } = this.props;
				onChangeLabel("title", activity.name);
				onChangeLabel("subtitle", moment(activity.start_date).format('YYYY-MM-DD HH:mm'));

				let sum = selectedActivities.reduce(function (prev, cur) {
					return { distance: prev.distance + cur.distance };
				})
				let sumTime = selectedActivities.reduce(function (prev, cur) {
					return { elapsed_time: prev.elapsed_time + cur.elapsed_time };
				})
				let dist = (sum.distance / 1000).toFixed(1)
				onChangeLabel("calculatedDistance", dist);

				if (sumTime.elapsed_time < 24 * 3600) {
					onChangeLabel("time", moment.utc(sumTime.elapsed_time * 1000).format("HH:mm:ss"));
				} else {
					onChangeLabel("time", Math.floor(sumTime.elapsed_time / 24 / 3600) + "d, " + moment.utc(sumTime.elapsed_time * 1000).format("H") + 'h');
				}
			}

		} else {
			this.props.onSelectActivities([], []);
		}


	}


	render() {
		let loginbutton = null;
		if (this.props.app.isLoggedIn === false) {
			//loginbutton = <Button href={global.stravaUrl} variant="contained" color="primary" style={{ marginTop: 20 }}>Connect to Strava</Button >;
			loginbutton = <ButtonBase
				focusRipple
				style={{

					marginTop: 20
				}}
				href={global.stravaUrl}
			>
				<img alt='Connect with Strava' src='img/btn_strava_connectwith_orange.png' width='193' />

			</ButtonBase>
		}

		return (
			<div style={{ position: 'relative' }}>
				<div width="100%" align="center">
					{loginbutton}
				</div>
				{this.props.data.isFetching && <div style={{ backgroundColor: 'rgba(255,255,255,.8)', position: 'absolute', zIndex: 1000, left: 0, width: '100%', height: '100%', textAlign: 'center' }}><CircularProgress style={{ position: 'absolute', top: '45%', left: '45%' }} size={100} thickness={2} /></div>}
				<Grid
					rows={this.props.data.activities.map((obj, i) => {
						return {/* year: moment(obj.start_date).format('YYYY'),*/date: moment(obj.start_date).format('YYYY-MM-DD HH:mm'), name: obj.name }
					})
					}
					columns={[
						/*{ name: 'year', title: 'Year' },*/
						{ name: 'date', title: 'Date' },
						{ name: 'name', title: 'Name' }
					]}>
					<SelectionState
						selection={this.props.data.selectedIndices}
						onSelectionChange={this.handleRowSelection}
					/>
					<GroupingState
						grouping={[{ columnName: 'year' }]}
					/>
					{/*<IntegratedGrouping/>*/}

					<FilteringState defaultFilters={[]} />
					<IntegratedFiltering />
					<IntegratedSelection />
					<VirtualTable color="primary" height={this.props.poster.layout.height - 119} />
					<TableSelection
						selectByRowClick
						highlightRow
						showSelectAll
						showSelectionColumn={true} />
					<TableHeaderRow />
					<TableFilterRow />

					{/*<TableGroupRow cellComponent={RxMyGroupCell}></TableGroupRow>*/}
				</Grid>

			</div>
		)
	}
}

export default MyActivitiesList;


// WEBPACK FOOTER //
// ./src/components/MyActivitiesList.js